import BaseClient from '@/app/model/api/response/baseApiClient'

class VarietyGrowthDetailApi extends BaseClient {
  public getVarietyGrowthDetail (id: string) {
    const path = '/v1/master/variety-growths/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new VarietyGrowthDetailApi()
